var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center transition",class:[_vm.cursor, _vm.sizeButton, _vm.buttonColor, _vm.customClass],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.click($event)}}},[_vm._t("icon-left"),_vm._t("default"),_vm._t("icon-right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }